// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"13485850","31":"fb9f73de","70":"7e0c91dd","125":"176104ae","744":"8745e3b7"}[chunkId] + ".chunk.js";
};